import { styled } from "@kivra/react-components";

export const ButtonContainer = styled.div({
  textAlign: "center",
  display: "flex",
  gap: "$spacing-20",
  flexDirection: "column",
  marginTop: "$spacing-40",
  padding: "$spacing-0",
});
